import { Box, Item } from 'devextreme-react/box';
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import {
	AcceptChangeOrderButton,
	CabinetDesignFiles,
	CFIInformationPanel,
	ConfirmChangeOrderButton,
	CustomerInformationPanel,
	ExitButton,
	RequestCancellationButton,
	RetailOrderCommunicationButton,
	RetailOrderDatesPanel,
	RetailOrderFilesButton,
	RetailOrderInformationPanel,
	RetailOrderNotes,
	RetailOrderPage,
	RetailOrderProducts,
	SaveChangesButton,
	StoreInformation,
	SubmitDesignButton,
	ViewChangeRequestButton
} from '../../../features/dealer/retail-order';
import '../../../css/order.scss';
import { useEffect } from 'react';
import { useTitle } from '../../../contexts/title';

export default function RetailOrderDetailsPage() {

	const pageTitle = useTitle();

	useEffect(() => {
		pageTitle.setTitle('Retail Order Details');
	}, [pageTitle])

	return (

		<RetailOrderPage>

			<Toolbar className='button-toolbar'>
				<ToolbarItem location={'before'}>
					<StoreInformation />
				</ToolbarItem>
				<ToolbarItem location={'after'}>
					<SaveChangesButton />
				</ToolbarItem>
				<ToolbarItem location={'after'}>
					<SubmitDesignButton />
				</ToolbarItem>
				<ToolbarItem location={'after'}>
					<ConfirmChangeOrderButton />
				</ToolbarItem>
				<ToolbarItem location={'after'}>
					<AcceptChangeOrderButton />
				</ToolbarItem>
				<ToolbarItem location={'after'}>
					<ViewChangeRequestButton />
				</ToolbarItem>
				<ToolbarItem location={'after'}>
					<RequestCancellationButton />
				</ToolbarItem>
				<ToolbarItem location={'after'}>
					<RetailOrderCommunicationButton />
				</ToolbarItem>
				<ToolbarItem location={'after'}>
					<RetailOrderFilesButton />
				</ToolbarItem>
				<ToolbarItem location={'after'}>
					<ExitButton />
				</ToolbarItem>
			</Toolbar>

			<Box>
				<Item ratio={1}>
					<RetailOrderInformationPanel />
				</Item>
				<Item ratio={1}>
					<CustomerInformationPanel />
				</Item>
				<Item ratio={1}>
					<CFIInformationPanel />
				</Item>
				<Item ratio={1}>
					<RetailOrderDatesPanel />
				</Item>
			</Box>

			<CabinetDesignFiles />

			<RetailOrderProducts />

			<RetailOrderNotes />

		</RetailOrderPage>
	)
}
